var _a;
import { composer } from '../../../component-decorators/composer';
import { Box, Button, EmptyState, Heading, TextButton } from 'wix-style-react';
import React from 'react';
import { config } from '../../../config';
// @ts-ignore
import s from '../error-page.scss';
import { ErrorPageType } from '../../..';
export var errorPageTypeMessagesMap = (_a = {},
    _a[ErrorPageType.NOT_FOUND] = {
        titleKey: 'error-page.not-found.title',
        subtitleKey: 'error-page.not-found.subtitle',
    },
    _a[ErrorPageType.INTERNAL_SERVER] = {
        titleKey: 'error-page.internal-server.title',
        subtitleKey: 'error-page.internal-server.subtitle',
    },
    _a[ErrorPageType.NOT_AVAILABLE_APP] = {
        titleKey: 'not-available-app.title',
        subtitleKey: 'not-available-app.subtitle',
    },
    _a);
export var ErrorPageHeader = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var appName = _a.appName, errorPageType = _a.errorPageType, t = _a.t;
    var _b = errorPageTypeMessagesMap[errorPageType], titleKey = _b.titleKey, subtitleKey = _b.subtitleKey;
    return (React.createElement("div", { "data-testid": errorPageType + "-error-page-header" },
        React.createElement(ErrorPageHeaderTitle, { appName: appName, errorPageType: errorPageType }),
        React.createElement(EmptyState, { theme: "page", title: t(titleKey), subtitle: t(subtitleKey, {
                appName: appName,
            }), dataHook: 'error-page-empty-state', image: React.createElement("img", { className: s.logo, src: config.marketplaceStaticsUrl + "assets/images/empty-state-generic-no-search-results.svg" }) },
            React.createElement(ErrorPageEmptyStateButtons, { errorPageType: errorPageType }))));
});
var ErrorPageHeaderTitle = function (_a) {
    var appName = _a.appName, errorPageType = _a.errorPageType;
    return appName && errorPageType === ErrorPageType.NOT_AVAILABLE_APP ? (React.createElement("div", { className: s.appName, "data-testid": "error-page-app-name." },
        React.createElement(Heading, { appearance: "H1", dataHook: 'error-page-app-name' }, appName))) : (React.createElement(Box, { height: "48px" }));
};
var ErrorPageEmptyStateButtons = composer()
    .withTranslation()
    .compose(function (_a) {
    var errorPageType = _a.errorPageType, t = _a.t;
    return (React.createElement("div", { className: s.emptyStateButtons },
        React.createElement(Button, { as: 'a', href: '/app-market', dataHook: 'error-page-button-explore' }, t('not-available-app.button.explore')),
        errorPageType === ErrorPageType.INTERNAL_SERVER && (React.createElement(TextButton, { dataHook: 'error-page-button-contact', className: s.contactButton, as: 'a', href: 'https://www.wix.com/support/conversations/category/contact' }, t('error-page.button.contact')))));
});
//# sourceMappingURL=error-page-header.js.map